module.exports = "/_next/static/images/ComputerApp-1d382802a8eae911fe5a96cdcb8d93e1.png";